import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';

import Input from '../../../../components/Input';
import Toggle from '../../../../components/Toggle';

export default function Form() {
  return (
    <SpaceBetween size="m">
      <Input name="text" label="Text" stretch />
      <Box>
        <SpaceBetween size="s">
          <Toggle
            defaultValue={true}
            label="Aktive"
            description="Kann dieser Eintrag zur Auswahl, z.B. bei Speisen, verwendet werden."
            name="is_active"
          />
        </SpaceBetween>
      </Box>
    </SpaceBetween>
  );
}
